import GTMEvents from './gtm';
import FBPixel from './fbpixel';

import { MailRuTracker } from './mailru';
import { YandexMetrika } from './yandex-metrika';

require('waypoints/lib/jquery.waypoints.min');
require('waypoints/lib/shortcuts/inview');

export default class Trackers {
    constructor(arg = {}) {
        this.yandexMetrika = new YandexMetrika();

        this.instances = {
            gtm: new GTMEvents(),
            fbpixel: new FBPixel()
        };
        if (!arg.onlyTrackers) {
            return;
        }

        for (let track in this.instances) {
            if (arg.onlyTrackers.indexOf(track) === -1 && this.instances.hasOwnProperty(track)) {
                delete this.instances[track];
            }
        }
    }

    backendPageViewed() {
        this.mailru = new MailRuTracker();
        let route = $('.main-container').data('route');

        switch (route) {
            case 'index':
                this.indexPageViewed();
                break;
            case 'catalog.section':
                this.categoryPageViewed();
                break;
            case 'catalog.product':
                this.productPageViewed();
                break;
            case 'cart':
                this.basketPageViewed();
                break;
            case 'order':
                this.orderPageViewed();
                break;
            case 'search':
                this.searchPageViewed();
                break;
            default:
                this.otherPageViewed();
                break;
        }
    }

    userAuthorized(user) {
        this.yandexMetrika.userAuthorized(user);
    }

    clientTimeSite(time = 190000){
        const _self = this;
        setTimeout(function (){
            _self.yandexMetrika.timeClient();
        }, time);
    }

    trigger(evType, arg) {
        for (let instName in this.instances) {
            if (typeof this.instances[instName][evType] === 'function' && this.instances.hasOwnProperty(instName)) {
                this.instances[instName][evType](arg[instName]);
            }
        }
    }

    getTracker(tracker) {
        return this.instances[tracker];
    }

    onAddToCart(arg = {}) {
        this.trigger('onAddToCart', arg);
    }

    onAddToFav(arg = {}) {
        this.trigger('onAddToFav', arg);
    }

    onSearch(arg = {}) {
        this.trigger('onSearch', arg);
    }

    onContentView(arg = {}) {
        this.trigger('onContentView', arg);
    }

    onSignUp(arg = {}) {
        this.trigger('onSignUp', arg);
    }

    onSignUpEnd(arg = {}) {
        this.trigger('onSignUpEnd', arg);
    }

    onCheckoutStart(arg = {}) {
        this.trigger('onCheckoutStart', arg);
    }

    onCheckoutEnd(arg = {}) {
        this.trigger('onCheckoutEnd', arg);
    }

    onAdviserWindow(arg = {}) {
        this.trigger('onAdviserWindow', arg);
    }

    onAdviserReply(arg = {}) {
        this.trigger('onAdviserReply', arg);
    }

    onFeedbackSend(arg = {}) {
        this.trigger('claimButton', arg);
    }

    onTabClick(arg = {}) {
        this.trigger('onTabClick', arg);
    }

    onSubscribe(arg = {}) {
        this.trigger('onSubscribe', arg);
    }

    onSubscriptionDone(arg = {}) {
        this.trigger('onSubscriptionDone', arg);
        this.trigger('onPMfrmSubscribe', arg);
    }

    onCallBackFormShow(arg = {}) {
        this.trigger('onCallBackFormShow', arg);
    }

    onCallBackButton(arg = {}) {
        this.trigger('onCallBackButton', arg);
    }

    onCallBackRequestSend(arg = {}) {
        this.trigger('onCallBackRequestSend', arg);
    }

    onBasketRefresh(arg = {}) {
        this.trigger('onBasketRefresh', arg);
    }

    onOneClickBuyButton(arg = {}) {
        this.trigger('onOneClickBuyButton', arg);
    }

    onOneClickBuyEnd(arg = {}) {
        this.trigger('onOneClickBuyEnd', arg);
    }

    onPMbtnTel(arg = {}) {
        this.trigger('PMbtnTel', arg);
    }

    onPMbtnFilter(arg = {}) {
        this.trigger('PMbtnFilter', arg);
    }

    onClickEvent(arg = {}) {
        this.trigger(arg.event, {gtm:{param1:arg.param}});
    }

    onClickPdf(arg = {}) {
        this.trigger(arg.event, {gtm:{param1:arg.param1, param2:arg.param2}});
    }

    onPMbtnFavorite(arg = {}) {
        this.trigger('PMbtnFavorite', {gtm:{param1:arg.param}});
    }

    onPMbtnAddToCart(arg = {}) {
        this.trigger('PMbtnAddToCart', {gtm:{param1:arg.param}});
    }

    onPMbtn1Click(arg = {}) {
        this.trigger('PMbtn1Click', {gtm:{param1:arg.param1, param2:arg.param2}});
    }

    onPMfrm1Click(arg = {}) {
        this.trigger('PMfrm1Click', {gtm:{param1:arg.param1, param2:arg.param2}});
    }

    onPMbtnFAQ(arg = {}) {
        this.trigger('PMbtnFAQ', arg);
    }

    onPMfrmCallMeContact(arg = {}) {
        this.trigger('PMfrmCallMeContact', arg);
    }

    onPMfrmFAQ(arg = {}) {
        this.trigger('PMfrmFAQ', arg);
    }

    onPMbtnCallMe(arg = {}) {
        this.trigger('PMbtnCallMe', arg);
    }

    onPMfrmCallMe(arg = {}) {
        this.trigger('PMfrmCallMe', arg);
    }

    onPMfrmReg(arg = {}) {
        this.trigger('PMfrmReg', arg);
    }

    onPMbtnReg(arg = {}) {
        this.trigger('PMbtnReg', arg);
    }

    onPMbtnComment(arg = {}) {
        this.trigger('PMbtnComment', arg);
    }

    onPMfrmComment(arg = {}) {
        this.trigger('PMfrmComment', arg);
    }

    onPMbtnAskQuestion(arg = {}) {
        this.trigger('PMbtnAskQuestion', arg);
    }

    onPMfrmAskQuestion(arg = {}) {
        this.trigger('PMfrmAskQuestion', arg);
    }

    onClickPromo(arg = {}) {
        this.trigger('ecommercePromoClick', {gtm:{ecommerce:arg}});
    }

    onViewPromo(arg = {}) {
        this.trigger('ecommercePromoView', {gtm:{ecommerce:arg}});
    }

    onShowNewProducts(arg = {}) {
        this.trigger('ecommerceImpressions', {gtm:{ecommerce:arg}});
    }

    onShowWatchedProducts(arg = {}) {
        this.trigger('ecommerceImpressions', {gtm:{ecommerce:arg}});
    }

    onShowAnalogProducts(arg = {}) {
        this.trigger('ecommerceImpressions', {gtm:{ecommerce:arg}});
    }

    onClickAddProduct(arg = {}) {
        this.trigger('ecommerceAdd', {gtm:{ecommerce:arg}});
    }

    onClickRemoveProduct(arg = {}) {
        this.trigger('ecommerceRemove', {gtm:{ecommerce:arg}});
    }
    onShowOrderCartStep1(arg = {}) {
        this.trigger('ecommerceCheckout', {gtm:{ecommerce:arg}});
    }
    onShowOrderStep(arg = {}) {
        this.trigger('ecommerceCheckout', {gtm:{ecommerce:arg}});
    }

    onShowcatalogProducts(arg = {}) {
        this.trigger('ecommerceImpressions', {gtm:{ecommerce:arg}});
    }

    onClickCatalogProducts(arg = {}) {
        this.trigger('ecommerceClick', {gtm:{ecommerce:arg}});
    }

    onClickWatched(arg = {}) {
        this.trigger('ecommerceClick', {gtm:{ecommerce:arg}});
    }

    onClickAnalog(arg = {}) {
        this.trigger('ecommerceClick', {gtm:{ecommerce:arg}});
    }

    onClickNewProducts(arg = {}) {
        this.trigger('ecommerceClick', {gtm:{ecommerce:arg}});
    }

    onShowProductCard(arg = {}) {
        this.trigger('ecommerceDetail', {gtm:{ecommerce:arg}});
    }

    onShowProductCardPopup(arg = {}) {
        this.trigger('ecommerceDetail', {gtm:{ecommerce:arg}});
    }

    addToCardFromCard(arg = {}) {
        this.trigger('ecommerceAdd', {gtm:{ecommerce:arg}});
    }

    addToCardFromList(arg = {}) {
        this.trigger('ecommerceAdd', {gtm:{ecommerce:arg}});
    }

    completeRegistration(arg = {}) {
        this.trigger('CompleteRegistration', arg);
    }

    indexPageViewed() {
        this.mailru.indexPageView();
    }

    categoryPageViewed() {
        this.mailru.categoryPageView();
    }

    productPageViewed() {
        this.mailru.productPageView($('.product-detail__action-btn').data('product-id'), $('.product-detail__price-sum').data('price'));
    }

    otherPageViewed() {
        this.mailru.otherPageView();
    }

    searchPageViewed() {
        this.mailru.searchPageView();
    }

    orderPageViewed() {
        this.mailru.orderPageView();
    }

    basketPageViewed() {
        let ids = [];
        let products = document.querySelectorAll('.cart__item .cart__item-content');
        products.forEach(product => {
            ids.push(product.getAttribute('data-product-id'));
        });

        this.mailru.basketPageView(ids, $('.basket-final-price').html());
    }
}



// WEBPACK FOOTER //
// ./blocks/tracker/tracker.js